export class HeroBanner {
    constructor(selector) {
      this.parallaxElement = document.querySelector(selector);
      if (this.parallaxElement) {
        this.init();
      }
    }

    init() {
      window.addEventListener('mousemove', this.moveBackground.bind(this));
    }

    moveBackground(e) {
      const movementStrength = 50; 
      const height = movementStrength / window.innerHeight;
      const width = movementStrength / window.innerWidth;
      const pageX = e.clientX - (window.innerWidth / 2);
      const pageY = e.clientY - (window.innerHeight / 2);
      const newvalueX = width * pageX * -1 - 25; 
      const newvalueY = height * pageY * -1 - 50; 

      this.parallaxElement.style.backgroundPosition = `${newvalueX}px ${newvalueY}px`;
    }
  }

  new HeroBanner('.hero-banner');